import React, { useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import api from '../services/api';
import { X } from 'lucide-react';
import toast from 'react-hot-toast';

const ModalMultiplosSucos = ({ onClose, onSuccess }) => {
  const [sabores, setSabores] = useState('');
  const [preco500ml, setPreco500ml] = useState('6.00');
  const [precoJarra, setPrecoJarra] = useState('10.00');
  const [criando, setCriando] = useState(false);
  const queryClient = useQueryClient();

  // Buscar estabelecimento
  const { data: estabelecimentoData } = useQuery(
    'estabelecimento-sucos',
    async () => {
      try {
        const response = await api.get('/api/estabelecimentos/me/estabelecimento');
        return response.data.data.estabelecimento;
      } catch (error) {
        if (error.response?.status === 404) {
          try {
            const response = await api.get('/api/estabelecimentos/padrao');
            return response.data.data.estabelecimento;
          } catch (padraoError) {
            return null;
          }
        }
        throw error;
      }
    },
    {
      retry: 1,
      refetchOnWindowFocus: false
    }
  );

  const estabelecimento = estabelecimentoData?._id;

  const handleCriar = async () => {
    if (!sabores.trim()) {
      toast.error('Digite pelo menos um sabor');
      return;
    }

    const preco500 = parseFloat(preco500ml) || 0;
    const precoJ = parseFloat(precoJarra) || 0;

    if (!preco500 || !precoJ) {
      toast.error('Preencha os preços de ambos os tamanhos');
      return;
    }

    if (!estabelecimento) {
      toast.error('Estabelecimento não encontrado');
      return;
    }

    setCriando(true);

    try {
      const saboresLista = sabores.split(',').map(s => s.trim()).filter(s => s);
      let sucessos = 0;
      let erros = 0;

      for (const sabor of saboresLista) {
        try {
          await api.post('/api/produtos', {
            nome: `SUCO DE ${sabor.toUpperCase()}`,
            categoria: 'SUCOS',
            estabelecimento: estabelecimento,
            preco: preco500, // Preço base (500ml)
            temVariacoes: true,
            variacoes: [
              {
                nome: `${sabor} - 500ml`,
                preco: preco500,
                disponivel: true,
                ordem: 0
              },
              {
                nome: `${sabor} - Jarra 1L`,
                preco: precoJ,
                disponivel: true,
                ordem: 1
              }
            ],
            disponivel: true
          });
          sucessos++;
        } catch (error) {
          console.error(`Erro ao criar suco ${sabor}:`, error);
          erros++;
        }
      }

      if (sucessos > 0) {
        toast.success(`${sucessos} suco(s) criado(s) com sucesso!`);
        queryClient.invalidateQueries('produtos');
        onSuccess();
      }

      if (erros > 0) {
        toast.error(`${erros} suco(s) não puderam ser criados`);
      }
    } catch (error) {
      toast.error('Erro ao criar sucos: ' + (error.response?.data?.message || error.message));
    } finally {
      setCriando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
        <div className="modal-header">
          <h3>🍹 Criar Múltiplos Sucos</h3>
          <button className="btn-icon" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <div className="form-group">
            <label>Sabores (separados por vírgula) *</label>
            <textarea
              value={sabores}
              onChange={(e) => setSabores(e.target.value)}
              placeholder="Ex: Laranja, Maracujá, Acerola, Limão, Abacaxi, Manga, Goiaba, Caju"
              rows={5}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid var(--gray-300)',
                borderRadius: '0.5rem',
                fontSize: '1rem'
              }}
            />
            <small style={{ color: '#666', display: 'block', marginTop: '0.5rem' }}>
              Digite os sabores separados por vírgula. Cada sabor será criado com os tamanhos 500ml e Jarra 1L.
            </small>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Preço 500ml (R$) *</label>
              <input
                type="number"
                step="0.01"
                value={preco500ml}
                onChange={(e) => setPreco500ml(e.target.value)}
                placeholder="6.00"
                required
              />
            </div>
            <div className="form-group">
              <label>Preço Jarra 1L (R$) *</label>
              <input
                type="number"
                step="0.01"
                value={precoJarra}
                onChange={(e) => setPrecoJarra(e.target.value)}
                placeholder="10.00"
                required
              />
            </div>
          </div>

          <div style={{ 
            padding: '1rem', 
            background: '#f0f9ff', 
            borderRadius: '0.5rem', 
            marginTop: '1rem',
            border: '1px solid #0ea5e9'
          }}>
            <p style={{ margin: 0, color: '#0369a1', fontSize: '0.9rem' }}>
              <strong>💡 Dica:</strong> Serão criados produtos separados para cada sabor, cada um com as variações de tamanho.
            </p>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleCriar}
              disabled={criando}
            >
              {criando ? 'Criando...' : '✅ Criar Todos os Sucos'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalMultiplosSucos;










